/* Piercora Wishlist — safe drawer version + header heart + fly animation */

(() => {
  if (window.__PC_WL_INIT__) return;
  window.__PC_WL_INIT__ = true;

  const LS_KEY = 'pc_wishlist_v5';

  const STR = {
    title: 'Twoja lista',
    emptyTitle: 'Nie dodano jeszcze żadnych produktów',
    emptyText: 'Kliknij w serduszko przy produkcie, aby zapisać go na liście.',
    remove: 'Usuń',
    close: 'Zamknij',
    added: 'Dodano do listy'
  };

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function escapeHtml(s) {
    return String(s ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        if (window.theme && theme.moneyFormat) {
          return Shopify.formatMoney(cents, theme.moneyFormat);
        }
      }
    } catch (e) {}
    const val = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    return `${val} zł`;
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function normalizeHandle(value) {
    if (!value) return null;

    if (typeof value === 'string') {
      const v = value.trim();
      if (!v || v === '[object Object]') return null;
      return v;
    }

    if (typeof value === 'object') {
      if (typeof value.handle === 'string' && value.handle.trim()) {
        return value.handle.trim();
      }
      return null;
    }

    return null;
  }

  function readWL() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];

      const cleaned = parsed.map(normalizeHandle).filter(Boolean);
      const unique = [...new Set(cleaned)];

      if (JSON.stringify(unique) !== JSON.stringify(parsed)) {
        localStorage.setItem(LS_KEY, JSON.stringify(unique));
      }

      return unique;
    } catch (e) {
      return [];
    }
  }

  function writeWL(arr) {
    try {
      const cleaned = [...new Set(arr.map(normalizeHandle).filter(Boolean))];
      localStorage.setItem(LS_KEY, JSON.stringify(cleaned));
    } catch (e) {}
    syncAllHearts();
    renderDrawerIfOpen();
  }

  function hasHandle(handle) {
    const h = normalizeHandle(handle);
    if (!h) return false;
    return readWL().includes(h);
  }

  function toggleHandle(handle) {
    const h = normalizeHandle(handle);
    if (!h) return false;

    const wl = readWL();
    const idx = wl.indexOf(h);

    if (idx >= 0) {
      wl.splice(idx, 1);
      writeWL(wl);
      return false;
    } else {
      wl.unshift(h);
      writeWL(wl);
      return true;
    }
  }

  function injectStyles() {
    if ($('#pc-wl-styles')) return;

    const css = `
.pc-wl-open{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: #111;
  -webkit-tap-highlight-color: transparent;
}
.pc-wl-open svg{
  width: 22px;
  height: 22px;
  display: block;
}
.pc-wl-open .pc-wl-ico-fill{
  display: none !important;
}

.pc-wl-overlay{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.28);
  opacity: 0;
  pointer-events: none;
  transition: opacity .35s ease;
  z-index: 9998;
}
.pc-wl-overlay.is-open{
  opacity: 1;
  pointer-events: auto;
}

.pc-wl-drawer{
  position: fixed;
  top: 0;
  right: 0;
  width: min(420px, 92vw);
  height: 100vh;
  background: #fff;
  transform: translateX(100%);
  transition: transform .45s cubic-bezier(.18,.84,.18,1);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  border-left: 1px solid rgba(0,0,0,.08);
}
.pc-wl-drawer.is-open{
  transform: translateX(0);
}

.pc-wl-head{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 14px;
  border-bottom: 1px solid rgba(0,0,0,.08);
}
.pc-wl-title{
  margin: 0;
  font-size: 14px;
  letter-spacing: .14em;
  text-transform: uppercase;
}
.pc-wl-close{
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0,0,0,.18);
  background: #fff;
  cursor: pointer;
}

.pc-wl-body{
  padding: 14px 18px 18px;
  overflow: auto;
}

.pc-wl-empty{
  padding: 48px 12px;
  text-align: center;
  color: rgba(0,0,0,.72);
}
.pc-wl-empty h3{
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 500;
}
.pc-wl-empty p{
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  opacity: .85;
}

.pc-wl-item{
  display: grid;
  grid-template-columns: 64px 1fr auto;
  gap: 14px;
  align-items: start;
  padding: 16px 0;
  border-bottom: 1px solid rgba(0,0,0,.08);
}
.pc-wl-link{
  display: contents;
  color: inherit;
  text-decoration: none;
}
.pc-wl-img{
  width: 64px;
  height: 64px;
  object-fit: contain;
  background: #f6f6f6;
}
.pc-wl-info{
  min-width: 0;
}
.pc-wl-name{
  margin: 0 0 10px;
  font-size: 12px;
  letter-spacing: .08em;
  text-transform: uppercase;
  line-height: 1.4;
}
.pc-wl-price{
  margin: 0;
  font-size: 13px;
  opacity: .75;
}
.pc-wl-remove{
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: #111;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  margin-top: 2px;
  opacity: .75;
  transition: opacity .18s ease, transform .18s ease;
}
.pc-wl-remove:hover{
  opacity: 1;
  transform: rotate(90deg);
}

.pc-wl-toast{
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 26px;
  background: #111;
  color: #fff;
  padding: 10px 16px;
  opacity: 0;
  transition: opacity .28s ease, transform .28s ease;
  z-index: 10000;
  font-size: 13px;
  letter-spacing: .06em;
}
.pc-wl-toast.is-show{
  opacity: 1;
  transform: translateX(-50%) translateY(-2px);
}

.pc-wl-fly{
  position: fixed;
  z-index: 10001;
  pointer-events: none;
  will-change: transform, opacity, left, top;
}
    `;

    const style = document.createElement('style');
    style.id = 'pc-wl-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureHeaderHeart() {
    let btn = $('.pc-wl-open');
    if (btn) return btn;

    const headerTargets = [
      '.header__icons',
      '.header-icons',
      '.site-header__icons',
      '.header__icon-list',
      '.header-actions'
    ];

    let target = null;
    for (const sel of headerTargets) {
      target = $(sel);
      if (target) break;
    }

    if (!target) return null;

    btn = document.createElement('button');
    btn.className = 'pc-wl-open';
    btn.type = 'button';
    btn.setAttribute('aria-label', STR.title);
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
          fill="none"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"/>
      </svg>
    `;
    target.prepend(btn);
    return btn;
  }

  function ensureDrawer() {
    injectStyles();
    ensureHeaderHeart();

    if ($('.pc-wl-drawer')) return;

    const overlay = document.createElement('div');
    overlay.className = 'pc-wl-overlay';
    overlay.addEventListener('click', closeDrawer);

    const drawer = document.createElement('aside');
    drawer.className = 'pc-wl-drawer';
    drawer.innerHTML = `
      <div class="pc-wl-head">
        <h3 class="pc-wl-title">${STR.title}</h3>
        <button class="pc-wl-close" type="button" aria-label="${STR.close}">✕</button>
      </div>
      <div class="pc-wl-body"></div>
    `;

    const closeBtn = drawer.querySelector('.pc-wl-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
  }

  function openDrawer() {
    ensureDrawer();

    const scrollBarW = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.paddingRight = scrollBarW ? `${scrollBarW}px` : '';

    const overlay = $('.pc-wl-overlay');
    const drawer = $('.pc-wl-drawer');

    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');

    renderDrawer();
  }

  function closeDrawer() {
    const overlay = $('.pc-wl-overlay');
    const drawer = $('.pc-wl-drawer');

    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');

    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
  }

  function drawerIsOpen() {
    const drawer = $('.pc-wl-drawer');
    return !!(drawer && drawer.classList.contains('is-open'));
  }

  function renderDrawerIfOpen() {
    if (drawerIsOpen()) renderDrawer();
  }

  function toast(text) {
    let t = $('.pc-wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'pc-wl-toast';
      document.body.appendChild(t);
    }
    t.textContent = text;
    t.classList.add('is-show');
    clearTimeout(t._tm);
    t._tm = setTimeout(() => t.classList.remove('is-show'), 1300);
  }

  function flyToHeader(fromBtn) {
    const headerBtn = ensureHeaderHeart();
    if (!headerBtn || !fromBtn) return;

    const a = fromBtn.getBoundingClientRect();
    const b = headerBtn.getBoundingClientRect();

    const fly = document.createElement('div');
    fly.className = 'pc-wl-fly';
    fly.style.left = `${a.left + a.width / 2}px`;
    fly.style.top = `${a.top + a.height / 2}px`;
    fly.style.transform = 'translate(-50%, -50%) scale(1)';
    fly.style.opacity = '1';
    fly.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" style="color:#c30000; display:block">
        <path d="M6.979 3.074a6 6 0 0 1 4.988 1.425l.037 .033l.034 -.03a6 6 0 0 1 4.733 -1.44l.246 .036a6 6 0 0 1 3.364 10.008l-.18 .185l-.048 .041l-7.45 7.379a1 1 0 0 1 -1.313 .082l-.094 -.082l-7.493 -7.422a6 6 0 0 1 3.176 -10.215z" fill="currentColor"/>
      </svg>
    `;
    document.body.appendChild(fly);

    const dur = 900;
    const start = performance.now();

    const x0 = a.left + a.width / 2;
    const y0 = a.top + a.height / 2;
    const x1 = b.left + b.width / 2;
    const y1 = b.top + b.height / 2;

    const ctrlX = (x0 + x1) / 2;
    const ctrlY = Math.min(y0, y1) - 120;

    const bez = (t, p0, p1, p2) => (1 - t) * (1 - t) * p0 + 2 * (1 - t) * t * p1 + t * t * p2;
    const ease = (t) => 1 - Math.pow(1 - t, 4);

    function frame(now) {
      const t = clamp((now - start) / dur, 0, 1);
      const e = ease(t);

      const x = bez(e, x0, ctrlX, x1);
      const y = bez(e, y0, ctrlY, y1);

      const s = 1 - e * 0.35;
      fly.style.left = `${x}px`;
      fly.style.top = `${y}px`;
      fly.style.transform = `translate(-50%, -50%) scale(${s})`;
      fly.style.opacity = String(1 - e * 0.2);

      if (t < 1) requestAnimationFrame(frame);
      else fly.remove();
    }

    requestAnimationFrame(frame);
  }

  async function fetchProduct(handle) {
    const h = normalizeHandle(handle);
    if (!h) return null;

    try {
      const res = await fetch(`/products/${encodeURIComponent(h)}.js`, {
        credentials: 'same-origin'
      });

      if (!res.ok) return null;

      const data = await res.json();
      if (!data || typeof data !== 'object') return null;

      return data;
    } catch (e) {
      return null;
    }
  }

  async function renderDrawer() {
    ensureDrawer();
    const body = $('.pc-wl-drawer .pc-wl-body');
    if (!body) return;

    const handles = readWL();

    if (!handles.length) {
      body.innerHTML = `
        <div class="pc-wl-empty">
          <h3>${STR.emptyTitle}</h3>
          <p>${STR.emptyText}</p>
        </div>
      `;
      return;
    }

    body.innerHTML = '';

    const products = await Promise.all(handles.map(fetchProduct));
    const validProducts = products.filter(Boolean);

    if (!validProducts.length) {
      writeWL([]);
      body.innerHTML = `
        <div class="pc-wl-empty">
          <h3>${STR.emptyTitle}</h3>
          <p>${STR.emptyText}</p>
        </div>
      `;
      return;
    }

    validProducts.forEach((p) => {
      const handle = normalizeHandle(p.handle);
      if (!handle) return;

      const img = Array.isArray(p.images) && p.images[0] ? p.images[0] : '';
      const firstVariant = Array.isArray(p.variants) && p.variants[0] ? p.variants[0] : null;
      const productUrl = `/products/${encodeURIComponent(handle)}`;

      const item = document.createElement('div');
      item.className = 'pc-wl-item';
      item.dataset.handle = handle;

      item.innerHTML = `
        <a class="pc-wl-link" href="${productUrl}">
          ${img ? `<img class="pc-wl-img" src="${img}" alt="${escapeHtml(p.title)}" loading="lazy">` : `<div class="pc-wl-img"></div>`}
          <div class="pc-wl-info">
            <div class="pc-wl-name">${escapeHtml(p.title)}</div>
            <div class="pc-wl-price">${firstVariant ? formatMoney(firstVariant.price) : ''}</div>
          </div>
        </a>
        <button class="pc-wl-remove" type="button" aria-label="${STR.remove}">✕</button>
      `;

      const removeBtn = item.querySelector('.pc-wl-remove');
      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          const wl = readWL().filter(h => h !== handle);
          writeWL(wl);
        });
      }

      body.appendChild(item);
    });
  }

  function syncAllHearts() {
    $$('.pc-wl-btn[data-wl-handle]').forEach((btn) => {
      const handle = normalizeHandle(btn.getAttribute('data-wl-handle'));
      if (!handle) return;
      btn.classList.toggle('is-on', hasHandle(handle));
    });
  }

  function bindGlobal() {
    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('.pc-wl-open');
      if (!openBtn) return;
      e.preventDefault();
      openDrawer();
    });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.pc-wl-btn[data-wl-handle]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = normalizeHandle(btn.getAttribute('data-wl-handle'));
      if (!handle) return;

      const added = toggleHandle(handle);
      btn.classList.toggle('is-on', added);

      if (added) {
        toast(STR.added);
        flyToHeader(btn);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawerIsOpen()) {
        closeDrawer();
      }
    });
  }

  function init() {
    injectStyles();
    ensureHeaderHeart();
    readWL();
    syncAllHearts();
    bindGlobal();

    document.addEventListener('shopify:section:load', () => {
      ensureHeaderHeart();
      syncAllHearts();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();